import { DecryptData, EncryptData } from './';
import { openDB } from 'idb';

// IndexedDB setup
const DB_NAME = 'baseHospitalDB';
const STORE_NAME = 'processedVisits';

export const saveToDB = async (type, data) => {
    const db = await openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        }
    });
    const encrypted = data; //EncryptData(data);
    await db.put(STORE_NAME, encrypted, type);
}

export const getFromDB = async (type) => {
    const db = await openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        }
    });
    const encrypted = await db.get(STORE_NAME, type);
    if (!encrypted) return null;
    try {
        return encrypted; //DecryptData(encrypted);
    } catch (e) {
        console.error('Decryption error:', e);
        return null;
    }
}

// Clear cache function
export const clearDBCache = async (type) => {
    const db = await openDB(DB_NAME, 1);
    await db.delete(STORE_NAME, type);
}
